<template>
  <v-container fluid fill-height>
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar color="transparent" class="elevation-0 secondary--text mb-4">
          <v-toolbar-title>Meus Convênios</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn slot="activator" icon color="primary" @click="drawer = !drawer">
              <v-icon>question_answer</v-icon>
            </v-btn>
            <span>Solicitação de convênio</span>
          </v-tooltip>
          <v-dialog
            width="600"
            :fullscreen="$vuetify.breakpoint.xs"
            lazy
            persistent
            v-model="dialogInsercao"
          >
            <v-btn icon color="info" slot="activator">
              <v-icon>add</v-icon>
            </v-btn>
            <cad-convenio @fechar="dialogInsercao = false" @carregar="carregarConvenios" @concluir="concluirInsercao()"></cad-convenio>
          </v-dialog>
        </v-toolbar>
      </v-flex>
      <v-flex xs12>
        <v-data-table :loading="loading" :items="convenios" hide-actions>
          <template v-slot:headers>
            <tr>
              <th></th>
              <th class="text-xs-left">Código do Convênio</th>
              <th class="text-xs-left">Desconto</th>
              <th class="text-xs-left">Quantidade de Códigos</th>
              <th class="text-xs-left">Item</th>
              <th class="text-xs-left">Privado</th>
              <th></th>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr>
              <td>
                <v-icon color="green">people</v-icon>
              </td>
              <td v-text="props.item.convenio.codigo"></td>
              <td>
                {{ props.item.desconto_em_reais !== null
                  ? `R$ ${parseFloat(props.item.desconto_em_reais).toFixed(2).replace('.', ',')}`
                  : `${props.item.percentual_desconto === null ? 0 : props.item.percentual_desconto}%` }}
              </td>
              <td v-text="props.item.qtd_codigos" v-if="props.item.qtd_codigos_limitado"></td>
              <td v-else v-text="'Ilimitados'"></td>
              <td> {{ props.item.item ? props.item.item.nome : '' }}</td>
              <td>
                <v-icon
                  :color="props.item.convenio.privado ? 'green' : 'red'"
                >
                  <template v-if="props.item.convenio.privado">
                    check_circle
                  </template>
                  <template v-else>
                    cancel
                  </template>
                </v-icon>
              </td>
              <td class="text-xs-right">
                <v-menu lazy min-width="180" max-width="180" offset-x left>
                  <v-btn slot="activator" icon>
                    <v-icon color="grey darken-2">more_vert</v-icon>
                  </v-btn>
                  <v-list class="pa-0" dense>
                    <v-list-tile avatar ripple @click="visualizar(props.item)">
                      <v-list-tile-content>
                        <v-list-tile-title class="text-xs-center body-2 font-weight-light">Visualizar</v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-avatar>
                        <v-icon color="info">remove_red_eye</v-icon>
                      </v-list-tile-avatar>
                    </v-list-tile>
                    <v-list-tile avatar ripple @click="editarDesconto(props.item)">
                      <v-list-tile-content>
                        <v-list-tile-title class="text-xs-center body-2 font-weight-light">Editar</v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-avatar>
                        <v-icon color="primary">edit</v-icon>
                      </v-list-tile-avatar>
                    </v-list-tile>
                    <template v-if="props.item.convenio.privado && !props.item.convenio.representante">
                      <v-list-tile avatar ripple @click="editarPermissoes(props.item)">
                        <v-list-tile-content>
                          <v-list-tile-title class="text-xs-center body-2 font-weight-light">Permissões</v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-avatar>
                          <v-icon color="green">person</v-icon>
                        </v-list-tile-avatar>
                      </v-list-tile>
                    </template>
                    <template v-else>
                      <v-tooltip bottom lazy>
                        <v-list-tile avatar style="opacity: 0.5" slot="activator">
                          <v-list-tile-content>
                            <v-list-tile-title class="text-xs-center body-2 font-weight-light">Permissões</v-list-tile-title>
                          </v-list-tile-content>
                          <v-list-tile-avatar>
                            <v-icon color="green">person</v-icon>
                          </v-list-tile-avatar>
                        </v-list-tile>
                        Essa funcionalidade só funciona em convênios privados ou gerados pelo posto
                      </v-tooltip>
                    </template>
                    <template v-if="props.item.convenio.privado">
                      <v-list-tile avatar ripple @click="
                        convenioSelected = props.item,
                        dialogConveniados = true
                      ">
                        <v-list-tile-content>
                          <v-list-tile-title class="text-xs-center body-2 font-weight-light">Conveniados</v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-avatar>
                          <v-icon color="secondary">groups</v-icon>
                        </v-list-tile-avatar>
                      </v-list-tile>
                    </template>
                    <template v-if="!props.item.convenio.representante">
                      <v-list-tile avatar ripple @click="editarImagem(props.item)">
                        <v-list-tile-content>
                          <v-list-tile-title class="text-xs-center body-2 font-weight-light">Editar imagem</v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-avatar>
                          <v-icon color="gray">photo</v-icon>
                        </v-list-tile-avatar>
                      </v-list-tile>
                    </template>
                    <template v-else>
                      <v-tooltip bottom lazy>
                        <v-list-tile avatar style="opacity: 0.5" slot="activator">
                          <v-list-tile-content>
                            <v-list-tile-title class="text-xs-center body-2 font-weight-light">Editar imagem</v-list-tile-title>
                          </v-list-tile-content>
                          <v-list-tile-avatar>
                            <v-icon color="gray">photo</v-icon>
                          </v-list-tile-avatar>
                        </v-list-tile>
                        Essa funcionalidade só funciona em convênios privados ou gerados pelo posto
                      </v-tooltip>
                    </template>
                    <v-list-tile avatar ripple @click="apagarConvenio(props.item.id)">
                      <v-list-tile-content>
                        <v-list-tile-title class="text-xs-center body-2 font-weight-light">Remover</v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-avatar>
                        <v-icon color="red">delete</v-icon>
                      </v-list-tile-avatar>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-dialog lazy width="400" :fullscreen="$vuetify.breakpoint.xs" v-model="dialogList">
      <list-codigos :convenio="convenioSelected"></list-codigos>
    </v-dialog>
    <v-dialog width="400" :fullscreen="$vuetify.breakpoint.xs" v-model="dialogPermissoes" persistent>
      <permissoes-convenio v-if="dialogPermissoes" :convenio_posto="convenioSelected" @fechar="fecharEdicao()"></permissoes-convenio>
    </v-dialog>
    <v-dialog
      width="600"
      :fullscreen="$vuetify.breakpoint.xs"
      lazy
      persistent
      v-model="editImgConvenio"
    >
      <edit-img-convenio v-if="editImgConvenio" @fechar="editImgConvenio = false" @edicao_fechar="edicaoFechar"  :convenio_posto="convenioSelected"></edit-img-convenio>
    </v-dialog>
    <v-dialog v-model="dialogVisualizar" v-if="dialogVisualizar" width="500" :fullscreen="$vuetify.breakpoint.xs">
      <visualizar-convenio :convenio_posto="convenioSelected" @fechar="dialogVisualizar = false"/>
    </v-dialog>
    <v-dialog v-model="dialogEditar" v-if="dialogEditar" width="500" :fullscreen="$vuetify.breakpoint.xs">
      <editar-convenio :convenio_posto="convenioSelected" @fechar="dialogEditar = false" @carregar="carregarConvenios"/>
    </v-dialog>
    <v-dialog v-model="dialogConveniados" v-if="dialogConveniados" width="70em" :fullscreen="$vuetify.breakpoint.xs">
      <visualizar-conveniados
        :convenio_posto="convenioSelected"
        @fechar="dialogConveniados = false, convenioSelected=undefined"
        @carregar="carregarConvenios"
      />
    </v-dialog>
    <v-navigation-drawer
        v-if="drawer"
        v-model="drawer"
        right
        width = 350vh
        temporary
        absolute
      >
        <Solicitacoes-convenio @carregar="carregarConvenios"/>
      </v-navigation-drawer>
  </v-container>
</template>

<script>

import SolicitacoesConvenio from '@/components/dialogs/SolicitacoesConvenio'
import VisualizarConvenio from '@/components/dialogs/VisualizarConvenio'
import EditarConvenio from '@/components/dialogs/EditarConvenio'
import VisualizarConveniados from '@/components/dialogs/Conveniados'
const ListCodigos = () => import('../../components/cadastros/ListCodigosPromocionaisConvenio')
const CadConvenio = () => import('../../components/cadastros/CadConvenio')
const PermissoesConvenio = () => import('../../components/dialogs/PermissoesConvenio')
const EditImgConvenio = () => import('../../components/dialogs/EditImgConvenio')

export default {
  components: {
    CadConvenio,
    ListCodigos,
    PermissoesConvenio,
    EditImgConvenio,
    SolicitacoesConvenio,
    VisualizarConvenio,
    EditarConvenio,
    VisualizarConveniados
  },
  data () {
    return {
      drawer: false,
      dialogInsercao: false,
      dialogList: false,
      dialogPermissoes: false,
      convenioSelected: null,
      editImgConvenio: false,
      dialogEditar: false,
      dialogVisualizar: false,
      dialogConveniados: false
    }
  },
  computed: {
    convenios () {
      return this.$store.getters.convenios
    },
    posto () {
      return this.$store.getters.posto
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  watch: {
    posto (val) {
      if (val) {
        this.carregarConvenios()
      }
    }
  },
  mounted () {
    if (this.posto) {
      this.carregarConvenios()
    }
  },
  methods: {
    editarPermissoes (convenio) {
      this.convenioSelected = convenio
      this.dialogPermissoes = true
    },
    editarDesconto (convenio) {
      this.convenioSelected = convenio
      this.dialogEditar = true
    },
    fecharEdicao () {
      this.convenioSelected = null
      this.dialogPermissoes = false
    },
    concluirInsercao () {
      this.dialogInsercao = false
      this.carregarConvenios()
    },
    listarCodigos (convenio) {
      this.convenioSelected = convenio
      this.dialogList = true
    },
    carregarConvenios () {
      this.$store.dispatch('listarConvenios')
    },
    apagarConvenio (convenio) {
      this.$store.dispatch('removerConvenio', convenio).then(() => {
        this.carregarConvenios()
      })
    },
    editarImagem (convenio) {
      this.convenioSelected = convenio
      this.editImgConvenio = true
    },
    edicaoFechar () {
      this.editImgConvenio = false
      this.convenioSelected = null
      this.carregarConvenios()
    },
    visualizar (convenio) {
      this.convenioSelected = convenio
      this.dialogVisualizar = true
    }
  }
}
</script>
